<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 d-flex justify-center>
        <HomePageMap></HomePageMap>
      </v-flex>
      <div class="mt-4">
        <p class="disclaimer-text" v-html="DISCLAIMER_TEXT"></p>
      </div>
    </v-layout>
  </v-container>
</template>
<script>

import HomePageMap from '../countrymap/HomePageMap'
import CONSTANTS from './../../../config/constant'
export default {
  name: 'Home',
  data: () => ({
    DISCLAIMER_TEXT: CONSTANTS.DISCLAIMER_TEXT
  }),
  mounted () {
    this.$globalFromValidation.forceTabActive(this.$route.name)
  },
  components: {
    'HomePageMap': HomePageMap
  },
  methods: {
    goToGlobalCodesLink () {
      this.$router.push({ name: 'GlobalCodes' })
    }
  }
}
</script>
